import { defineStore } from 'pinia'
import { useGlobalStore } from '@stores/global'
import _ from 'lodash'

export const useSubmissionStore = defineStore('submission', {
	state: () => {
		const globalStore = useGlobalStore()
		return {
			success: false,
			processing: false,
			fileUploading: false,
			form: {
				activation: globalStore.activation?.slug || null,
				full_name: null,
				email: null,
				country: null,
				platform: null,
				order_id: null,
				order_file: null,
				agree: false,
				marketing_consent: false,
			},
			errors: {},
		}
	},
	getters: {
		completed: (state) => {
			return Object.values(state.form).every((value) => value != null && value !== '') && state.form.agree == true
		},
	},
	actions: {
		submit() {
			const global = useGlobalStore()
			this.processing = true
			axios
				.post('/api/submit', this.form)
				.then(() => {
					this.processing = false
					this.success = true
					try {
						fathom.trackEvent('Submitted ' + global.activation.name + ' Form')
					} catch (error) {
						console.error(error)
					}
				})
				.catch((error) => {
					this.processing = false
					this.success = false
					if (error.response.status === 422) {
						this.errors = error.response.data.errors
					}
				})
		},
	},
})
